import StaffLoginForm from "@/components/Auth/StaffLoginForm";

export default function AdminLoginPage() {
    return (
        <StaffLoginForm
            title="Back Office Login"
            subtitle="Sign in to the Admin / Back Office portal"
            backgroundImage="/images/assets/global_admin_futuristic_1.png"
        />
    );
}
